export default "__VITE_ASSET__BrT9vAui__"